<template>
  <div class="card-details" :class="$i18n.locale">
    <!-- Check if it's an array -->
    <template v-if="Array.isArray(normalizedItems)">
      <div v-for="(card, index) in normalizedItems" :key="index" class="card-box">
        <h5 class="title">
          {{ $i18n.locale === "ar" ? "تفاصيل الكارت" : "Card Details" }}
        </h5>
        <div class="card-body">
          <div class="row">
            <span class="label">
              {{ $i18n.locale === "ar" ? "اسم الكارت" : "Card Name" }}
            </span>
            <span class="value">{{ card.card_name }}</span>
          </div>

          <div class="row">
            <span class="label">
              {{ $i18n.locale === "ar" ? "الرقم التسلسلي" : "Serial Number" }}
            </span>
            <span class="value">{{ card.serial_number }}</span>
          </div>

          <div class="row">
            <span class="label">
              {{ $i18n.locale === "ar" ? "الكود الخاص به" : "Card Code" }}
            </span>
            <span class="value">{{ card.card_code }}</span>
          </div>

          <div class="row price">
            <span class="label">
              {{ $i18n.locale === "ar" ? "سعر الكارت" : "Card Price" }}
            </span>

            <div class="price-value">
              <span :class="getValueClass(card.value)">
                {{ String(card.value) }}
              </span>
              <div class="currency-icon">
                {{ $i18n.locale === "ar" ? "دينار ليبي" : "LYD" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- If it's a single object -->
    <template v-else>
      <div class="card-box">
        <h5 class="title">
          {{ $i18n.locale === "ar" ? "تفاصيل الكارت" : "Card Details" }}
        </h5>
        <div class="card-body">
          <div class="row">
            <span class="label">
              {{ $i18n.locale === "ar" ? "اسم الكارت" : "Card Name" }}
            </span>
            <span class="value">{{ normalizedItems.card_name }}</span>
          </div>

          <div class="row">
            <span class="label">
              {{ $i18n.locale === "ar" ? "الرقم التسلسلي" : "Serial Number" }}
            </span>
            <span class="value">{{ normalizedItems.serial_number }}</span>
          </div>

          <div class="row">
            <span class="label">
              {{ $i18n.locale === "ar" ? "الكود الخاص به" : "Card Code" }}
            </span>
            <span class="value">{{ normalizedItems.card_code }}</span>
          </div>

          <div class="row price">
            <span class="label">
              {{ $i18n.locale === "ar" ? "سعر الكارت" : "Card Price" }}
            </span>

            <div class="price-value">
              <span :class="getValueClass(normalizedItems.value)">
                {{ String(normalizedItems.value) }}

                <span class="currency-icon">
                  {{ $i18n.locale === "ar" ? "دينار ليبي" : "LYD" }}
                </span>
              </span>

            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "CardDetails",
  props: {
    item: {
      type: [Object, Array], // Can be object or array
      required: true,
    },
  },
  computed: {
    // Normalize so we can handle both array or single
    normalizedItems() {
      return this.item;
    },
  },
  methods: {
    getValueClass(value) {
      const len = String(value).length;
      if (len < 3) return "value_amount";
      if (len === 3) return "value_amount_three";
      if (len === 4 || len === 5) return "value_amount_more";
      if (len > 5) return "value_amount_six";
      return "";
    },
  },
};
</script>